/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface GrowthModelTypesResponse
 */
export interface GrowthModelTypesResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof GrowthModelTypesResponse
   */
  types?: Array<GrowthModelTypesResponseTypesEnum>;
}

export const GrowthModelTypesResponseTypesEnum = {
  SkrettingSalmon: 'skretting-salmon',
  EgiSalmon: 'egi-salmon',
  Sgr: 'sgr',
  Ittt: 'ittt',
  Gammon: 'gammon',
} as const;

export type GrowthModelTypesResponseTypesEnum =
  (typeof GrowthModelTypesResponseTypesEnum)[keyof typeof GrowthModelTypesResponseTypesEnum];
